/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_ExtensionInputs */

const en_pricing_feature_extension = /** @type {(inputs: Pricing_Feature_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save articles with the browser extension`)
};

const es_pricing_feature_extension = /** @type {(inputs: Pricing_Feature_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda artículos con la extensión del navegador`)
};

/**
* | output |
* | --- |
* | "Save articles with the browser extension" |
*
* @param {Pricing_Feature_ExtensionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_extension = /** @type {((inputs?: Pricing_Feature_ExtensionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_ExtensionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_feature_extension(inputs)
	return en_pricing_feature_extension(inputs)
});